






























import { IPRCFilter, TypeSelectedResponse } from "@/models";
import RateChangesModule from "@/store/modules/rate-changes";
import DaysSame from "@/views/rate-changes/filters/DaysSame.vue";
import FacilityLocation from "@/views/rate-changes/filters/FacilityLocation.vue";
import OccupancyPercentage from "@/views/rate-changes/filters/OccupancyPercentage.vue";
import UnitArea from "@/views/rate-changes/filters/UnitArea.vue";
import UnitType from "@/views/rate-changes/filters/UnitType.vue";
import VarianceAmount from "@/views/rate-changes/filters/VarianceAmount.vue";
import VariancePercentage from "@/views/rate-changes/filters/VariancePercentage.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const rateChanges = namespace(RateChangesModule.name);

@Component({
  name: "RateChangeFilter",
  components: {
    DaysSame,
    FacilityLocation,
    OccupancyPercentage,
    UnitArea,
    UnitType,
    VarianceAmount,
    VariancePercentage
  }
})
export default class RateChangeFilter extends Vue {
  // ===== Store ===== //
  @rateChanges.Action private removeFilter!: (id: number) => void;
  // ===== Props ===== //
  @Prop(Number) private readonly filter!: IPRCFilter;
  // ===== Data ===== //
  private selectedFilter: TypeSelectedResponse | null = null;
  private filterTypes: TypeSelectedResponse[] = [
    {
      parameter: "rent_days_unchanged",
      value: "Days Same",
      text: "",
      componentName: "DaysSame"
    },
    {
      parameter: "facilities_location_code",
      value: "Facility Location",
      text: "",
      componentName: "FacilityLocation"
    },
    {
      parameter: "occupancy_pct",
      value: "Occupancy Percentage",
      text: "",
      componentName: "OccupancyPercentage"
    },
    {
      parameter: "var",
      value: "Standard Rate Var $",
      text: "",
      componentName: "VarianceAmount"
    },
    {
      parameter: "var_pct",
      value: "Standard Rate Var %",
      text: "",
      componentName: "VariancePercentage"
    },
    {
      parameter: "facility_units_area",
      value: "Unit Area",
      text: "",
      componentName: "UnitArea"
    },
    {
      parameter: "facilities_unit_type",
      value: "Unit Type",
      text: "",
      componentName: "UnitType"
    }
  ];
  // ===== Methods ===== //
  private handleRemoveFilter(id: number): void {
    this.removeFilter(id);
    this.$emit("removeFilter", this.filter);
  }
}
